<template>
  <div class="table-form form">
    <el-form :model="form" ref="ruleForm" label-width="220px" class="ruleForm">
      <el-form-item label="管理人名称" style="width: 100% !important">
        <el-input
          v-model="form.glInstitutionName"
          :disabled="disable"
        ></el-input>
      </el-form-item>

      <el-form-item label="管理人类型">
        <el-select
          v-model="form.glInstitutionType"
          placeholder="请选择"
          :disabled="disable"
        >
          <el-option
            value="股权、创业类"
            label="股权、创业类"
            key="0"
          ></el-option>
          <el-option value="证券类" label="证券类" key="1"></el-option>
          <el-option value="其他" label="其他" key="2"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="在中基协登记时间">
        <el-date-picker
          v-model="form.associtionRegistedTime"
          type="date"
          placeholder="选择日期"
          :disabled="disable"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
      </el-form-item>

      <el-form-item label="中基协登记编码">
        <el-input
          v-model="form.associtionRegistedNo"
          :disabled="disable"
        ></el-input>
      </el-form-item>

      <el-form-item label="控股类型">
        <el-input v-model="form.kgType" :disabled="disable"></el-input>
      </el-form-item>

      <el-form-item label="实际控制人">
        <el-input v-model="form.realControlMan" :disabled="disable"></el-input>
      </el-form-item>

      <el-form-item label="员工数量">
        <el-input
          type="number"
          v-model="form.staffCount"
          :disabled="disable"
        ></el-input>
      </el-form-item>

      <el-form-item label="管理基金数量">
        <el-input
          type="number"
          v-model="form.manageFundCount"
          :disabled="disable"
        ></el-input>
      </el-form-item>

      <el-form-item label="契约型基金数量">
        <el-input
          type="number"
          v-model="form.contractFundCount"
          :disabled="disable"
        ></el-input>
      </el-form-item>

      <el-form-item label="未托管基金数量">
        <el-input
          type="number"
          v-model="form.wtgFundCount"
          :disabled="disable"
        ></el-input>
      </el-form-item>

      <el-form-item label="未在中基协备案的基金数量">
        <el-input
          type="number"
          v-model="form.wbaFundCount"
          :disabled="disable"
        ></el-input>
      </el-form-item>

      <el-form-item v-if="!isGQForm" label="管理基金规模（万元）">
        <el-input
          type="number"
          v-model="form.manageFundAdmitted"
          :disabled="disable"
        ></el-input>
      </el-form-item>
      <el-form-item v-if="isGQForm" label="管理基金规模（认缴：万元）">
        <el-input
          type="number"
          v-model="form.manageFundAdmitted"
          :disabled="disable"
        ></el-input>
      </el-form-item>
      <el-form-item v-if="isGQForm" label="管理基金规模（实缴：万元）">
        <el-input
          type="number"
          v-model="form.manageFundPaid"
          :disabled="disable"
        ></el-input>
      </el-form-item>

      <el-form-item v-if="isGQForm" label="投资者总数">
        <el-input
          type="number"
          v-model="form.investorCount"
          :disabled="disable"
        ></el-input>
      </el-form-item>
      <el-form-item v-if="!isGQForm" label="机构投资者总数">
        <el-input
          type="number"
          v-model="form.investorCount"
          :disabled="disable"
        ></el-input>
      </el-form-item>
      <el-form-item label="自然人投资者总数">
        <el-input
          type="number"
          v-model="form.natureInvestorCount"
          :disabled="disable"
        ></el-input>
      </el-form-item>
      <el-form-item label="当前实际情况是否与中基协登记备案信息一致">
        <el-select
          v-model="form.currentConsistent"
          placeholder="请选择"
          :disabled="disable"
        >
          <el-option
            :value="item.value"
            :label="item.label"
            v-for="(item, index) of options"
            :key="index"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="是否设有分公司">
        <el-select
          type="number"
          v-model="form.hasBranch"
          placeholder="请选择"
          :disabled="disable"
        >
          <el-option
            :value="item.value"
            :label="item.label"
            v-for="(item, index) of optionNum"
            :key="index"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="近期是否被其他部门处罚">
        <el-select
          v-model="form.punishmentSituation"
          placeholder="请选择"
          :disabled="disable"
        >
          <el-option
            :value="item.value"
            :label="item.label"
            v-for="(item, index) of options"
            :key="index"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="相关主体和个人是否列为失信被执行人">
        <el-select
          type="number"
          v-model="form.untrust"
          placeholder="请选择"
          :disabled="disable"
        >
          <el-option
            :value="item.value"
            :label="item.label"
            v-for="(item, index) of optionNum"
            :key="index"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="相关主体和个人是否从事P2P业务">
        <el-select
          type="number"
          v-model="form.p2p"
          placeholder="请选择"
          :disabled="disable"
        >
          <el-option
            :value="item.value"
            :label="item.label"
            v-for="(item, index) of optionNum"
            :key="index"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="相关主体和个人当前涉诉数量">
        <el-input
          type="number"
          v-model="form.ssCount"
          :disabled="disable"
        ></el-input>
      </el-form-item>
      <el-form-item label="公司开展的其他业务">
        <el-input v-model="form.otherBusiness" :disabled="disable"></el-input>
      </el-form-item>
      <el-form-item label="投诉纠纷处理情况">
        <el-input
          v-model="form.tsjfHandleSituation"
          :disabled="disable"
        ></el-input>
      </el-form-item>
      <!-- <el-form-item label="重大事项变更情况">
        <el-input v-model="form.largeChange" :disabled="disable"></el-input>
      </el-form-item> -->
      <el-form-item label="已经爆发的风险情况">
        <el-input
          v-model="form.alreadyRiskSituation"
          :disabled="disable"
        ></el-input>
      </el-form-item>
      <el-form-item label="目前存在的风险点">
        <el-input v-model="form.currentRisk" :disabled="disable"></el-input>
      </el-form-item>
      <el-form-item label="需要说明的事项" style="width: 100% !important">
        <el-input
          type="textarea"
          v-model="form.instructions"
          :disabled="disable"
        ></el-input>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    tableData: {
      type: Object,
      default: function () {
        return {};
      },
    },
    disable: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      // 是否已完成中基协登记
      isRegister: false,
      // 是否办理中
      transact: false,
      form: {
        // 管理人名称
        glInstitutionName: "",
        // 管理人类型
        glInstitutionType: "",
        // 在中基协登记时间
        associtionRegistedTime: "",
        // 中基协登记编码
        associtionRegistedNo: "",
        // 控股类型
        kgType: "",
        // 实际控制人
        realControlMan: "",
        // 员工数量
        staffCount: "",
        // 管理基金数量
        manageFundCount: "",
        // 契约型基金数量
        contractFundCount: "",
        // 未托管基金数量
        wtgFundCount: "",
        // 未在中基协备案的基金数量
        wbaFundCount: "",
        // 管理基金规模（认缴：万元）/管理基金规模
        manageFundAdmitted: "",
        // 管理基金规模（实缴：万元）/证券类没有使用
        manageFundPaid: "",
        // 投资者总数/ 机构投资者总数
        investorCount: "",
        // 自然人投资者总数
        natureInvestorCount: "",
        // 当前实际情况是否与中基协登记备案信息一致
        currentConsistent: "",
        // 是否设有分公司
        hasBranch: "",
        // 近期是否被其他部门处罚
        punishmentSituation: "",
        // 相关主体和个人是否列为失信被执行人
        untrust: "",
        // 相关主体和个人是否从事P2P业务
        p2p: "",
        // 相关主体和个人当前涉诉数量
        ssCount: "",
        // 公司开展的其他业务
        otherBusiness: "",
        // 投诉纠纷处理情况
        tsjfHandleSituation: "",
        // 重大事项变更情况--后面统一输入
        largeChange: "",
        // 已经爆发的风险情况
        alreadyRiskSituation: "",
        // 目前存在的风险点
        currentRisk: "",
        // 需要说明的事项
        instructions: "",
      },
      options: [
        {
          label: "是",
          value: "1",
        },
        {
          label: "否",
          value: "0",
        },
      ],
      optionNum: [
        {
          label: "是",
          value: 1,
        },
        {
          label: "否",
          value: 0,
        },
      ],
      //默认展示股权类表单
      isGQForm: true,
    };
  },

  mounted() {
    console.log("this.$route.query", this.$route.query);
    if (this.$route.query.reportFillType != "gq") {
      this.isGQForm = false;
    }

    this.getData(this.tableData);
  },

  methods: {
    getData(val) {
      if (!Object.keys(val).length) return;
      if (val.associtionRegisted) {
        this.isRegister = true;
      } else {
        this.isRegister = false;
        this.transact = false;
      }

      if (val.isRegisting) {
        this.transact = true;
      }

      val.registedTime = val.registedTime
        ? this.$moment(val.registedTime).format("YYYY-MM-DD")
        : this.$moment(new Date()).format("YYYY-MM-DD");
      val.registePlanTime = val.registePlanTime
        ? this.$moment(val.registePlanTime).format("YYYY-MM-DD")
        : this.$moment(new Date()).format("YYYY-MM-DD");
      this.form = this.$lodash.cloneDeep(val);
    },

    changeTransact(val) {
      this.transact = val;
    },

    changeRegister(val) {
      this.isRegister = val;
    },
  },

  watch: {
    tableData: {
      handler(newValue) {
        this.getData(this.tableData);
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.register {
  border-bottom: 1px solid #e1e1e1 !important;
}

.form {
  margin-top: 20px;
}
.table-form >>> .el-form-item .el-form-item__label {
  height: 54px !important;
}
</style>
